import { render, staticRenderFns } from "./AlcoholAndHealth.vue?vue&type=template&id=09f3eacd&"
import script from "./AlcoholAndHealth.vue?vue&type=script&lang=js&"
export * from "./AlcoholAndHealth.vue?vue&type=script&lang=js&"
import style0 from "./AlcoholAndHealth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports